$(function () {
    $('a').on('click', function () {
        let href = $(this).attr("href");
        let target = $(href);

        if (target.length && href[0] === '#') {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 500);
        }

    })

    $('form').on('submit', function (event) {
        event.preventDefault();

        let form = this;

        $(form).parent('.container').find('.alert').addClass('hidden');

        let data = $(form).serialize();

        $(form).find('input,textarea,button').attr('disabled', true);

        grecaptcha.ready(function() {
            grecaptcha.execute('6LczyhUjAAAAAIno1MWvWzDW8d8-19K4F5zwUw88', {action: 'login'}).then(function(token) {

                $.ajax({
                    url: "mail.php",
                    method: 'POST',
                    data: data + '&token=' + token,
                    error: function () {
                        $(form).parent('.container').find('.alert-danger').removeClass('hidden');
                    },
                    success: function (response) {
                        $(form).parent('.container').find('.alert-info').removeClass('hidden');
                        $(form).find('input,textarea').val('');
                    }
                });
            })
        });

        $(form).find('input,textarea,button').removeAttr('disabled');
    })

    $('.content').on('click', function () {
        $('.popup').each(function () {
            if (parseInt($(this).css('right')) === 0) {
                $(this).addClass('hidden');
                $('.content').removeClass('hidden');
                $('.content-mask')
                    .animate({
                        opacity: 0
                    }, 300, function () {
                        $(this).css('display', 'none');
                    });
            }
        })
    })
});